import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import Swal from 'sweetalert2';
import { LoginService } from '../../../login/login.service';
import { ActFijoService } from '../act-fijo.service';
import {PaginadorService, PageBusquedaObject} from '../../../paginador/paginador.service';
@Component({
  selector: 'app-catalogo-act-fijo',
  templateUrl: './catalogo-act-fijo.component.html',
  styleUrls: ['./catalogo-act-fijo.component.css'],
  preserveWhitespaces: true
})
export class CatalogoActFijoComponent implements OnInit {
  cargado: boolean;
  items: any[] = [];
  busqueda: PageBusquedaObject = new PageBusquedaObject();
  totalItems: number;
  titulo_paginador = 'act-fijo-paginador';
  activo: any = {idEmp: 0, idSuc: 0, del: 0, al: 1000, contable: true, fiscal: false, depreciar_todo: false,
    depreciacion_de: 1, simular: true, fecha_depr: '', mes: 1, poliza_cada_activo_depr: false, poliza_sin_afectar_depr: false};
  rotate: any;
  @ViewChild('titulo') title: ElementRef;
  constructor(private paginadorService: PaginadorService, public loginService: LoginService, private service: ActFijoService) { }

  ngOnInit(): void {
    this.busqueda = this.paginadorService.getBusquedaCatalogo(this.titulo_paginador);
    this.busqueda.page1 = true;
    this.activo.idEmp = this.loginService.empresa as number;
    this.activo.idSuc = this.loginService.sucursal as number;
    this.activo.mes = 1;
    this.cargarCatalogo();
    this.activo.fecha_depr = this.fechaActual();
  }
  depreciacionDeToogle(valor: number) {
      this.activo.depreciacion_de = valor;
  }
  simularToogle(valor: boolean) {
    this.activo.simular = valor;
  }
  fechaActual(): String {
    const d = new Date();
    const currDate = d.getDate();
    const currMonth = d.getMonth() + 1;
    const currYear = d.getFullYear();
    return currYear + '-' + ((currMonth < 10) ? '0' + currMonth : currMonth) + '-' + ((currDate < 10) ? '0' + currDate : currDate);
  }
  ValidaSoloNumeros() {
    var e = e || window.event;
    if ((e.keyCode < 46) || (e.keyCode > 57)) {
      e.returnValue = false;
      e.preventDefault();
    }
  }
  cargarCatalogo() {
  this.cargado = false;
    this.mostrarMensajeCarga();
    this.busqueda.criteriaSearch['emp'] = this.loginService.empresa;
    this.service.catalogo(this.busqueda).subscribe(
      response => {
        this.items = response.contenido.content;
        this.totalItems = response.contenido.totalElements;
          this.cerrarMensajeCarga();
          this.paginadorService.setBusquedaCatalogo(this.titulo_paginador,this.busqueda);
      }, err => {
        this.cerrarMensajeCarga();
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
        console.log(err);
      });
  }

  eliminar(dtoDelete: any): void {
    Swal.fire({
      title: 'Atención',
      text: `¿Está seguro de dar de baja este elemento?`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.value) {
        this.service.delete(dtoDelete.id, this.loginService.usuario.id).subscribe(response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
          this.buscarEnCatalogo();
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire('TNK Ledger', err.error.mensaje, 'error');
        });
      }
    });
  }
  simular() {
      this.service.getSimulacionXls(this.activo).subscribe(
        response => {
          const a = document.createElement('a');
          a.href = URL.createObjectURL(response);
          a.download = 'simulacion';
          document.body.appendChild(a);
          a.click();
        }
      );
  }
  depreciar(): void {
    Swal.fire({
      title: '¿Está seguro de realizar la depreciación?',
      text: `Se recomienda antes de de realizar la depreciación, simular los resultados`,
      showCancelButton: true,
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.value) {
        this.service.postDepreciacion(this.activo).subscribe(response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
        }, err => {
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire('TNK Ledger', err.error.mensaje, 'error');
        });
      }
    });
  }
  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 1;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
   this.cargarCatalogo();
  }
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page;
    this.cargarCatalogo();
  }
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 1;
    this.cargarCatalogo();
  }

  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }

  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 10;
    this.busqueda.pageNumber = 1;
    this.cargarCatalogo();
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
